import {useTargetYTDActual} from "../../hooks/kpiHooks";

const SAMScoreboardYTDActual = ({target}) => {
    const ytdActual = useTargetYTDActual(target);

    return (<>{ytdActual}</>);
}

export default SAMScoreboardYTDActual;